import styled from 'styled-components';

export const DisclaimersContainer = styled.div`
  margin: 48px 0;
`;

export const DisclaimersMessage = styled.p`
  color: #6C6F7F;
`;